import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
//import * as AOS from 'aos';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-k12-and-elearning',
  templateUrl: './k12-and-elearning.component.html',
  styleUrls: ['./k12-and-elearning.component.scss']
})
export class K12AndElearningComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka Enterprise | K-12 & E-Learning");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka’s advanced AI not only helps students improve their writing but also learn best academic writing practices as they write." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka Enterprise | K-12 & E-Learning" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka’s advanced AI not only helps students improve their writing but also learn best academic writing practices as they write." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/enterprise/K12-and-elearning.webp' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Enterprise | K-12 & E-Learning' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka’s advanced AI not only helps students improve their writing but also learn best academic writing practices as they write." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/enterprise/K12-and-elearning.webp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/k12-and-elearning' });

    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Enterprise","item":"https://www.trinka.ai/enterprise"},{"@type":"ListItem","position":3,"name":"K12 and Elearning","item":"https://www.trinka.ai/enterprise/k12-and-elearning"}]}
    `;

    this._renderer2.appendChild(this._document.head, script);
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }
  
  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/paterson.png", "altText": "paterson" },
    { "imgSrc": "/assets/images/client_logos/abraham-lincoln.png", "altText": "abraham lincoln" },
    { "imgSrc": "/assets/images/client_logos/act.png", "altText": "act" },
    { "imgSrc": "/assets/images/client_logos/AguaFriaUnion.png", "altText": "agua fria union" },
    { "imgSrc": "/assets/images/client_logos/almosa.png", "altText": "almosa" },
    { "imgSrc": "/assets/images/client_logos/amalAcademy.png", "altText": "amal academy" },
    { "imgSrc": "/assets/images/client_logos/AmericanschoolofDubai.png", "altText": "American school of Dubai" },
    { "imgSrc": "/assets/images/client_logos/lusaka.png", "altText": "lusaka" }
  ];

}
